import React from 'react';

function formatDisplayValue(value) {
  if (value == null || value === '') return '—';
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

const InfoCard = ({ title, data }) => {
  const entries = data && typeof data === 'object' ? Object.entries(data) : [];

  return (
    <div className="flex min-w-0 w-full flex-col rounded-lg border border-black/[0.08] bg-white p-[0.65rem] px-[0.85rem]">
      <h2 className="mb-[0.4rem] border-b border-black/[0.06] pb-[0.4rem] text-sm font-semibold tracking-tight text-[var(--text-ink,#171717)] text-balance">
        {title}
      </h2>
      {entries.length === 0 ? (
        <p className="m-0 text-[0.8125rem] italic text-[var(--text-secondary)]">No data for this section.</p>
      ) : (
        <dl className="m-0 flex max-h-[11.5rem] flex-col gap-0 overflow-x-hidden overflow-y-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {entries.map(([key, value]) => (
            <div
              key={key}
              className="grid grid-cols-[minmax(0,1fr)_minmax(0,1.25fr)] items-start gap-x-[0.65rem] gap-y-1 border-b border-black/[0.06] py-[0.3rem] text-[0.8125rem] leading-snug last:border-b-0 last:pb-0 max-[480px]:grid-cols-1 max-[480px]:gap-1"
            >
              <dt className="m-0 font-medium text-[var(--text-secondary)] [overflow-wrap:anywhere]">
                {key}
              </dt>
              <dd className="m-0 text-right font-semibold text-[var(--text-primary)] [overflow-wrap:anywhere] max-[480px]:text-left max-[480px]:font-medium">
                {formatDisplayValue(value)}
              </dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
};

export default InfoCard;
